export enum UserRoles {
  ACCOUNTING = 'ACCOUNTING',
  ADMINISTRATOR = 'ADMINISTRATOR',
  LECTURER = 'LECTURER',
  PROGRAMME_COORDINATOR = 'PROGRAMME_COORDINATOR',
  STUDENT = 'STUDENT',
  STAFF = 'STAFF',
}
